import React, { useEffect, useRef, useState } from 'react';
import { monthsinYear } from '../../../../Constants/HomePage';
import { ErrorText } from '../styled';
import { calculateDueDate } from '../utils';
import { useRouter } from 'next/router';
import { getStageWeekDay } from '../../../PregnancyPage/utils';
import { clickedCtaEvent } from '../../../PregnancyPage/utils/instrumentation';
import { createRippleEffectRelative } from '../../../../Utils/helper';

function DueDateCalculator(props) {
  const {
    setDueDate,
    DateCalculateBtn,
    buttonText,
    SelectDate,
    setCurrentWeek,
  } = props;
  const yearRef = useRef();
  const monthRef = useRef();
  const dayRef = useRef();
  const router = useRouter();
  const currentYear = new Date().getFullYear();
  const [showError, setShowError] = useState(false);

  const prepareDate = () => {
    let selectedDay = dayRef.current.selectedOptions?.[0]?.value;
    let selectedMonth = monthRef.current.selectedOptions?.[0]?.value;
    let selectedYear = yearRef.current.selectedOptions?.[0]?.value;
    if (selectedDay == '0' || selectedMonth == '0' || selectedYear == '0') {
      setShowError(true);
    } else {
      let date = selectedMonth + '/' + selectedDay + '/' + selectedYear;
      const dueDate = calculateDueDate(date);
      let query = '';
      if (window.location.search == '') {
        query = '?result=true';
      } else {
        query = window.location.search + '&result=true';
      }
      router.push(window.location.pathname + query, '', {
        shallow: true,
      });
      setDueDate(dueDate);
      if (setCurrentWeek) {
        const weekDay = getStageWeekDay(dueDate);
        if (weekDay.currentWeek <= 42 && weekDay.currentWeek >= 4) {
          setCurrentWeek(weekDay?.currentWeek);
        }
        clickedCtaEvent('calculate');
      }
    }
  };
  useEffect(() => {
    insertFields();
  }, []);
  const insertFields = () => {
    monthsinYear.forEach((month, index) => {
      let opt = document.createElement('option');
      opt.value = index + 1;
      opt.innerHTML = month;
      monthRef.current.appendChild(opt);
    });
    for (let i = 1; i <= 31; i++) {
      let opt = document.createElement('option');
      opt.value = i;
      opt.innerHTML = i;
      dayRef.current.appendChild(opt);
    }
    let year = new Date().getFullYear();
    let years = [year, year - 1];
    years.forEach((year) => {
      let opt = document.createElement('option');
      opt.value = year;
      opt.innerHTML = year;
      yearRef.current.appendChild(opt);
    });
  };
  const monthChanged = () => {
    dayRef.current.value = '0';
    let days = getDays();
    refreshDays(days);
  };
  const getDays = () => {
    let year = yearRef.current.selectedOptions?.[0]?.value;
    let month = parseInt(monthRef.current.selectedOptions?.[0]?.value);
    if (year == '0') {
      year = currentYear;
    }
    let numberOfDays = new Date(year, month, 0).getDate();
    return numberOfDays;
  };
  const refreshDays = (days) => {
    for (let i = 29; i <= 31; i++) {
      dayRef.current[i].disabled = false;
    }
    for (let i = days + 1; i <= 31; i++) {
      dayRef.current[i].disabled = true;
    }
  };
  const yearChanged = (e) => {
    if (monthRef.current.value != '0') {
      let days = getDays();
      refreshDays(days);
      if (dayRef.current.selectedOptions?.[0]?.value >= days) {
        monthRef.current.value = '0';
        dayRef.current.value = '0';
      }
    }
  };
  return (
    <>
      <SelectDate>
        <select
          ref={yearRef}
          onChange={() => {
            yearChanged();
          }}
        >
          <option selected hidden value={'0'}>
            Year
          </option>
        </select>
        <select ref={monthRef} onChange={() => monthChanged()}>
          <option selected hidden value={'0'}>
            Month
          </option>
        </select>
        <select ref={dayRef}>
          <option selected hidden value={'0'}>
            Day
          </option>
        </select>
      </SelectDate>
      <ErrorText visible={showError} preg>
        Please add info above to calculate your due date
      </ErrorText>
      <DateCalculateBtn
        id="prepareDatebtn"
        onClick={(e) => {
          createRippleEffectRelative(
            e,
            document.getElementById('prepareDatebtn'),
          );
          setTimeout(() => {
            prepareDate(e);
          }, 400);
        }}
      >
        {buttonText}
      </DateCalculateBtn>
    </>
  );
}

export default DueDateCalculator;
